module.exports = __webpack_public_path__ + "img/accessory_pants_09.5cb39fdc.svg";